// extracted by mini-css-extract-plugin
module.exports = {"checkbox-wrapper":"_32bbee5fda--checkbox-wrapper--zvOZ7","focused":"_32bbee5fda--focused--R0YQA"};